module.exports = __webpack_public_path__ + "static/media/GQ.a42ed491.svg";